import React from 'react';
export const TriggerIcon = () => (
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.6006 7.43455L0.561761 7.49402C0.380712 7.81772 0.611772 8.23507 0.999995 8.23507L4.37666 8.23451L3.3116 13.0542C3.19311 13.5899 3.89965 13.8976 4.21136 13.4459L9.41154 5.91158L9.44715 5.85194C9.61188 5.5284 9.37926 5.12792 8.99999 5.12792L5.63999 5.12762L6.68522 0.954484C6.81752 0.425976 6.12866 0.097273 5.80078 0.532456L0.6006 7.43455Z"
      fill="white"
    />
  </svg>
);
